import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import homePage from './views/homePage.vue'
import Cookie from 'vue-cookie'
import store from '@/vuex/store'
import notfount from '@/views/404'
import Home from './views/Home.vue'
import routes from './routes'
Vue.use(Router)
var arr = [{
		path: '/',
		redirect: '/login'
	},
	{
		path: '/login',
		component: Login,
		name: '',
		hidden: true
	},
	{
		path: '/index',
		name: '首页',
		iconCls: 'fa fa-home fa-1x',
		component: Home,
		leaf: true,
		children: [{
			path: '/index',
			name: '首页',
			component: () =>
				import('@/views/home/index')
		}]
	},
	{
		path: '/homePage',
		component: homePage,
		name: 'homes',
		hidden: true
	},
	{
		path: '*',
		component: notfount,
		name: '',
		hidden: true
	}
]
const router = new Router({
	routes: arr	
})

router.beforeEach((to, from, next) => {
	const userToken = Cookie.get('userToken')
	if (userToken) {
		if (to.path === '/login') {
			next()
		} else {
			if (from.path === '/login') { //在login的时候正常执行一次
				next()
			} else {
				const i = Cookie.get('menuIndex')
				if (i < 2) {
					if (store.getters.getRoutes.length == 0) {
						var r = store.dispatch('getRouterLIst')
						r.then(routes => {
							router.addRoutes(routes)
							console.log(routes, '99909090')
							store.commit('SET_ROUTES', routes)
							next({ ...to,
								replace: true
							})
						})
						var getset1 = store.dispatch('getRouterSet')
						getset1.then(routes2 => {
							router.addRoutes(routes2)
							store.commit('SET_SETTINGROUTES', routes2)
							next({ ...to,
								replace: true
							})
						})
					} else {
						next()
					}
				} else {
					next()
				}
			}
		}
		next()
	} else {
		if (to.path === '/login') {
			// alert('用户授权信息已过期，请重新登录')
			next()
		} else {
			next('/login')
		}
	}
})

// router.afterEach(() => {
//   iView.LoadingBar.finish()
// })

export default router



// WEBPACK FOOTER //
// ./src/router.js